import React, { useState } from 'react';
import PDFViewer from './PDFViewer';

interface PDFViewButtonProps {
  pdfUrl: string;
  buttonText?: string;
  className?: string;
  iconOnly?: boolean;
}

const PDFViewButton: React.FC<PDFViewButtonProps> = ({
  pdfUrl,
  buttonText = 'View PDF',
  className = '',
  iconOnly = false
}) => {
  const [showPDF, setShowPDF] = useState(false);

  const openPDF = () => setShowPDF(true);
  const closePDF = () => setShowPDF(false);

  const defaultButtonClass = "flex items-center gap-2 bg-accent hover:bg-accent/80 text-white px-4 py-2 rounded-md transition-colors";
  const iconButtonClass = "p-2 rounded-md bg-accent hover:bg-accent/80 text-white";
  const buttonClass = iconOnly ? iconButtonClass : defaultButtonClass;

  return (
    <>
      <button
        onClick={openPDF}
        className={className || buttonClass}
        aria-label={buttonText}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
        {!iconOnly && buttonText}
      </button>

      {showPDF && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={closePDF}
          ></div>

          {/* Modal */}
          <div className="relative w-full max-w-4xl max-h-[95vh] overflow-hidden bg-secondary rounded-lg shadow-xl flex flex-col animate-fadeIn">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700">
              <div className="flex items-center">
                <div className="mr-3 p-2 rounded-full bg-accent/20">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-accent">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">PDF Document</h3>
                  <p className="text-sm text-gray-400 truncate max-w-[260px]">{pdfUrl.split('/').pop()}</p>
                </div>
              </div>
              <button
                onClick={closePDF}
                className="p-2 text-gray-400 hover:text-white rounded-full hover:bg-gray-700"
                aria-label="Close PDF"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Document Viewer */}
            <div className="flex-1 overflow-hidden p-6 bg-gray-800">
              <PDFViewer url={pdfUrl} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PDFViewButton;
